module.exports = __webpack_public_path__ + "img/Dai6-2-re.f9f5de61.png";